import { createBrowserRouter, Navigate } from 'react-router-dom'
import App from './App.js'
import LandingPage from './pages/LandingPage.js'
import AuthPage from './pages/AuthPage.js'
import OnboardingPage from './pages/OnboardingPage.js'
import DashboardPage from './pages/DashboardPage.js'

import ExtensionPage from './pages/ExtensionPage.js'
import UsagePage from './pages/UsagePage.js'
import PricingPage from './pages/PricingPage.js'
import TermsPage from './pages/TermsPage.js'
import PrivacyPage from './pages/PrivacyPage.js'
import PrivateRoute from './components/PrivateRoute.js'
import AppShell from './components/AppShell.js'

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  {
    path:    '/',
    element: <App />,
    children: [
      { index: true, element: <LandingPage /> },
      { path: 'auth',    element: <AuthPage /> },
      { path: 'pricing', element: <PricingPage /> },
      { path: 'terms',   element: <TermsPage /> },
      { path: 'privacy', element: <PrivacyPage /> },
      {
        element: <PrivateRoute />,
        children: [
          { path: 'onboarding', element: <OnboardingPage /> },
          {
            element: <AppShell />,
            children: [
              { path: 'dashboard',  element: <DashboardPage /> },
              { path: 'create',     element: <Navigate to="/dashboard" replace /> },
              { path: 'extension',  element: <ExtensionPage /> },
              { path: 'usage',      element: <UsagePage /> },
              /* Redirects from old routes */
              { path: 'settings',   element: <Navigate to="/usage" replace /> },
              { path: 'billing',    element: <Navigate to="/usage" replace /> },
            ],
          },
        ],
      },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
])
